import * as React from 'react';
import { DefaultButton, mergeStyles, HighContrastSelector } from '@fluentui/react';
import { getPreviewLabelCalloutWithStrings } from './getPreviewLabelCallout';
import { Loading } from '../Loading';
import { getFFXHostUxIcon } from '@fluidx/icons/lib/useIconNames/ffxHostUx';
import { ThemeColorPalette, ThemeColorPaletteShared } from '@fluidx/component-ux';
export const previewButtonStyles = {
    root: {
        backgroundColor: ThemeColorPalette.Neutral.neutralLight,
        height: 24,
        fontSize: '12px',
        fontWeight: 600,
        border: '0 solid transparent',
        padding: '0px 6px',
        marginTop: 10,
        marginLeft: 8,
        selectors: {
            [HighContrastSelector]: {
                backgroundColor: 'buttonface',
                color: 'buttontext'
            }
        }
    },
    rootHovered: {
        backgroundColor: ThemeColorPalette.Neutral.neutralQuaternaryAlt,
        selectors: {
            [HighContrastSelector]: {
                backgroundColor: 'buttonface',
                MsHighContrastAdjust: 'none',
                forcedColorAdjust: 'none'
            },
            '.ms-Button-icon': {
                selectors: {
                    [HighContrastSelector]: {
                        color: 'highlight',
                        MsHighContrastAdjust: 'none',
                        forcedColorAdjust: 'none'
                    }
                }
            }
        }
    },
    rootPressed: {
        backgroundColor: ThemeColorPalette.Neutral.neutralQuaternary,
        selectors: {
            [HighContrastSelector]: {
                backgroundColor: 'buttonface',
                color: 'buttontext'
            },
            '.ms-Button-icon': {
                selectors: {
                    [HighContrastSelector]: {
                        color: 'buttontext'
                    }
                }
            }
        }
    },
    icon: {
        fontSize: '16px',
        width: 16,
        color: ThemeColorPaletteShared.Gray180,
        selectors: {
            [HighContrastSelector]: {
                color: 'buttontext',
                MsHighContrastAdjust: 'none',
                forcedColorAdjust: 'none'
            }
        }
    }
};
export const buttonWrapperStyles = mergeStyles({
    display: 'inline-block'
});
export const PreviewButton = /*#__PURE__*/ React.memo(function PreviewButton(props) {
    const { appColors , previewButtonLabel , locale , identityType  } = props;
    const buttonWrapperRef = React.useRef(null);
    const [isCalloutVisible, setCalloutVisible] = React.useState();
    const PreviewLabelCallout = React.useMemo(()=>/*#__PURE__*/ React.lazy(()=>getPreviewLabelCalloutWithStrings(locale, identityType)), [
        locale,
        identityType
    ]);
    const onShow = ()=>setCalloutVisible(true);
    const onDismiss = ()=>setCalloutVisible(false);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: buttonWrapperRef,
        className: buttonWrapperStyles
    }, /*#__PURE__*/ React.createElement(DefaultButton, {
        styles: previewButtonStyles,
        iconProps: {
            iconName: getFFXHostUxIcon('FFXInfo')
        },
        // eslint-disable-next-line react/jsx-no-bind
        onClick: onShow
    }, previewButtonLabel)), isCalloutVisible && /*#__PURE__*/ React.createElement(React.Suspense, {
        fallback: /*#__PURE__*/ React.createElement(Loading, null)
    }, /*#__PURE__*/ React.createElement(PreviewLabelCallout, {
        appColors: appColors,
        target: buttonWrapperRef.current,
        // eslint-disable-next-line react/jsx-no-bind
        onDismiss: onDismiss
    })));
});
